import { render } from "./NewsItemView.vue?vue&type=template&id=49ae4930&scoped=true"
import script from "./NewsItemView.vue?vue&type=script&lang=js"
export * from "./NewsItemView.vue?vue&type=script&lang=js"

import "./NewsItemView.vue?vue&type=style&index=0&id=49ae4930&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ae4930"]])

export default __exports__